import * as React from "react";
import { useRef } from "react";
import usePluginEntities from "hooks/usePluginEntities";
const useMessageListPluggableBulkActions = () => {
  const modalRefs = useRef({});
  const pluggableActions = usePluginEntities("views.components.widgets.messageTable.messageBulkActions");
  const availableActions = pluggableActions.filter((action) => action.useCondition ? !!action.useCondition() : true);
  if (!availableActions.length) return { pluggableBulkActions: null, pluggableBulkActionModals: null };
  const actions = availableActions.map(({ component: PluggableMessageBulkAction, key }) => /* @__PURE__ */ React.createElement(PluggableMessageBulkAction, { key: `bulk-message-action-${key}`, modalRef: () => modalRefs.current[key] }));
  const actionModals = availableActions.filter(({ modal }) => !!modal).map(({ modal: ActionModal, key }) => /* @__PURE__ */ React.createElement(
    ActionModal,
    {
      key: `bulk-message-action-modal-${key}`,
      ref: (r) => {
        modalRefs.current[key] = r;
      }
    }
  ));
  return { pluggableBulkActions: actions, pluggableBulkActionModals: actionModals };
};
export default useMessageListPluggableBulkActions;
